import { ComponentInstall } from "../../utils";
import Blank from "./src";

export default ComponentInstall(Blank);
